import { apiSlice } from "../app/api/apiSlice";

export const userEmployeesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserEmployees: builder.query({
            query: ({account_id,paginate}) => `/user/user_employees/${account_id}/${0}/${paginate}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserEmployees']
        }),
        getUserEmployeesPageChange: builder.mutation({
            query: ({account_id, paginate, search, page}) => `user/user_employees/${account_id}/${search}/${paginate}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserEmployees']
        }),
        getUserEmployeesSearch: builder.mutation({
            query: ({account_id, paginate, search, page}) => `user/user_employees/${account_id}/${search}/${paginate}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserEmployees']
        }),
        createUserEmployee: builder.mutation({
            query: (input) => ({
                url: `user/create-employee`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['UserEmployees']
        }),
        editUserEmployee: builder.mutation({
            query: (input) => ({
                url: `user/edit-employee/${input.id}`,
                method: 'PUT',
                body: { ...input }
            }),
            invalidatesTags: ['UserEmployees']
        }),
        getEmployeeById: builder.query({
            query: (id) => `/user/employee/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserEmployees']
        }),
        deleteEmployee: builder.mutation({
            query: (id) => ({
                url: `user/delete-employee/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['UserEmployees']
        }),
    })
})

export const {
    useCreateUserEmployeeMutation,
    useEditUserEmployeeMutation,
    useGetUserEmployeesQuery,
    useGetEmployeeByIdQuery,
    useGetUserEmployeesPageChangeMutation,
    useGetUserEmployeesSearchMutation,
    useDeleteEmployeeMutation,
} = userEmployeesApiSlice

